import { render } from "./details_card.html?vue&type=template&id=15dff0f0&external"
import script from "./details_card.js?vue&type=script&lang=js&external"
export * from "./details_card.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__